"use client";

import { visaSearchSchema } from "@/feature/visa/search/schema/visa-search-zod.schema";
import type { IVisaSearchSchema } from "@/feature/visa/search/types/visa.types";

const VISA_SEARCH_SESSION_KEY = "visa:search:last:v1";

function cloneVisaSearchData(data: IVisaSearchSchema): IVisaSearchSchema {
  return {
    country: data.country ? { ...data.country } : null,
    visa_type: data.visa_type ? { ...data.visa_type } : null,
    travelers: data.travelers,
  };
}

export function saveLastVisaSearch(data: IVisaSearchSchema): void {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(
      VISA_SEARCH_SESSION_KEY,
      JSON.stringify(cloneVisaSearchData(data)),
    );
  } catch {
    // Ignore sessionStorage failures.
  }
}

export function getLastVisaSearch(): IVisaSearchSchema | null {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.sessionStorage.getItem(VISA_SEARCH_SESSION_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as IVisaSearchSchema;
    const result = visaSearchSchema.safeParse(parsed);

    if (!result.success) {
      window.sessionStorage.removeItem(VISA_SEARCH_SESSION_KEY);
      return null;
    }

    return cloneVisaSearchData(result.data);
  } catch {
    window.sessionStorage.removeItem(VISA_SEARCH_SESSION_KEY);
    return null;
  }
}
